export const DASHBOARD_ROOT_URL = "espace-client"
